import { useQuery } from "react-query";
import { useAuthState } from "react-firebase-hooks/auth";
import auth from "../firebase.init";

const API_BASE = process.env.REACT_APP_apiHostLink;

export const useDonorQueryStats = (days = 30) => {
  const [user] = useAuthState(auth);

  return useQuery(
    ["donor-query", days],
    async () => {
      const token = await user.getIdToken();
      const res = await fetch(`${API_BASE}/api/admin/donor-query?days=${days}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error("Failed to fetch donor query stats");
      return res.json();
    },
    { enabled: !!user }
  );
};
